import type { WebSite, Organization } from 'schema-dts'

type HomePageSchema = {
  '@context': string
  '@graph': [WebSite, Organization]
}

const homePageSchema: HomePageSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      url: 'https://recovery.com',
      name: 'Recovery.com',
      alternateName: ['recovery.com', 'RehabPath', 'Luxury Rehabs']
    },
    {
      '@type': 'Organization',
      name: 'Recovery.com',
      url: 'https://recovery.com',
      logo: {
        '@type': 'ImageObject',
        url: 'https://res.cloudinary.com/rehabpath/image/upload/v1720713161/assets/logos/logo-schema.png'
      },
      contactPoint: [
        {
          '@type': 'ContactPoint',
          telephone: '+1-608-716-8926',
          contactType: 'customer support'
        },
        {
          '@type': 'ContactPoint',
          telephone: '+1-608-716-8926',
          contactType: 'sales'
        }
      ],
      sameAs: [
        'https://www.instagram.com/recoverydotcom/',
        'https://www.facebook.com/recoverydotcom/',
        'https://x.com/DotComRecovery',
        'https://www.linkedin.com/company/recoverydotcom/',
        'https://www.pinterest.com/recoverydotcom/'
      ]
    }
  ]
}

export default homePageSchema
